import { render, staticRenderFns } from "./RequestRgUpload.vue?vue&type=template&id=4526f94d&scoped=true"
import script from "./RequestRgUpload.vue?vue&type=script&lang=js"
export * from "./RequestRgUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526f94d",
  null
  
)

export default component.exports